module.exports = __webpack_public_path__ + "9a2e3a0dba6835906a2990944d9e21aa.svg";